export const checkIsPhone = (phone: string) =>
  !!phone.replaceAll(' ', '').match(/\+38\d{10}/);
